import { getUmpireDetailRequest } from "../repositories/umpire_detail_repository";
export const UmpireDetailService = () => {
    const fetchUmpireDetails = async (setUmpireDetails) => {
        try {
            const response = await getUmpireDetailRequest();
            if (response?.success) {
                setUmpireDetails(response.data);
            }
        } catch (error) {
            console.error("Failed to fetch umpire details.");
        }
    };
    return {
        fetchUmpireDetails,
    };
};
